<template>
  <CModal
    :title="'Ficha de la Propiedad - ' + (property.code || '')"
    color="info"
    :show.sync="showModal"
    size="xl"
  >
    <CRow>
      <CCol :md="hasImages ? 7 : 12" v-if="hasImages">
        <h5 class="section-title">Fotos de la propiedad</h5>
        <div class="image-viewer">
          <img class="main-image" :src="activeImageUrl" alt="Foto de la propiedad" />
          <div class="mt-2 text-right" v-if="activeImageId > 0">
            <CButton color="danger" size="sm" @click="deleteImage(activeImageId)">Eliminar foto seleccionada</CButton>
          </div>
          <div class="thumbs" v-if="images.length > 1">
            <button
              v-for="(image, index) in images"
              :key="image.url + '-' + index"
              type="button"
              class="thumb-btn"
              :class="{ active: image.url === activeImageUrl }"
              @click="setActiveImage(image)"
            >
              <img :src="image.url" alt="Miniatura" />
            </button>
          </div>
        </div>
      </CCol>

      <CCol :md="hasImages ? 5 : 12">
        <div class="sheet-row"><b>Nombre:</b> {{ safeValue(property.name) }}</div>
        <div class="sheet-row"><b>Codigo:</b> {{ safeValue(property.code) }}</div>
        <div class="sheet-row"><b>Tipo:</b> {{ safeValue(property.type) }}</div>
        <div class="sheet-row"><b>Departamento:</b> {{ safeValue(property.departament) }}</div>
        <div class="sheet-row"><b>Resguardo:</b> {{ safeValue(getCurrentPerson()) }}</div>
        <div class="sheet-row"><b>Tipo de propiedad:</b> {{ safeValue(property.property_type) }}</div>
        <div class="sheet-row"><b>Predial:</b> {{ safeValue(property.predial) }}</div>
        <div class="sheet-row"><b>Clave catastral:</b> {{ safeValue(property.catastral_code) }}</div>
        <div class="sheet-row"><b>Superficie catastral:</b> {{ safeValue(property.catastral_area) }}</div>
        <div class="sheet-row"><b>Ubicacion:</b> {{ safeValue(property.location) }}</div>
        <div class="sheet-row"><b>Tipo de documento:</b> {{ safeValue(property.document_type) }}</div>
        <div class="sheet-row"><b>Documento:</b> {{ safeValue(property.document) }}</div>
        <div class="sheet-row"><b>Instrumento legal:</b> {{ safeValue(property.legal_instrument) }}</div>
        <div class="sheet-row"><b>Observaciones:</b> {{ safeValue(property.observations) }}</div>
      </CCol>
    </CRow>

    <template #footer>
      <CButton color="info" @click="printRecord">Imprimir</CButton>
      <CButton color="secondary" @click="closeModal">Cerrar</CButton>
    </template>
  </CModal>
</template>

<script>
import ws from '../../services/properties'
import store from '../../store'

export default {
  name: 'PropertyProfileModal',
  data () {
    return {
      showModal: false,
      property: {},
      images: [],
      activeImageUrl: '',
      activeImageId: 0
    }
  },
  computed: {
    hasImages () {
      return this.images.length > 0
    }
  },
  methods: {
    openModal (item) {
      this.property = item || {}
      this.images = this.parseImages(item)
      this.setActiveImage(this.images.length > 0 ? this.images[0] : null)
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
      this.property = {}
      this.images = []
      this.activeImageUrl = ''
      this.activeImageId = 0
    },
    async printRecord () {
      if (!this.property || !this.property.id) {
        store.commit('toast', { color: 'warning', message: 'No se encontro el registro para imprimir.' })
        return
      }

      await ws.downloadProfileSheet({ id: this.property.id })
    },
    setActiveImage (image) {
      if (!image) {
        this.activeImageUrl = ''
        this.activeImageId = 0
        return
      }

      this.activeImageUrl = image.url || ''
      this.activeImageId = image.id || 0
    },
    async deleteImage (id) {
      if (!id) return

      if (!window.confirm('Estas seguro que deseas eliminar esta foto?')) {
        return
      }

      const response = await ws.deleteImage({ id: id })
      if (response.type === 'success') {
        this.images = this.images.filter((item) => item.id !== id)
        this.setActiveImage(this.images.length > 0 ? this.images[0] : null)
        store.commit('toast', { color: 'success', message: response.message })
        this.$emit('updated')
        return
      }

      store.commit('toast', { color: response.type, message: response.message })
    },
    parseImages (item) {
      const imageList = []

      const pushImage = (value, id = 0) => {
        if (!value) return

        let url = value

        if (typeof value === 'object') {
          url = value.filename || value.image || ''
        }

        if (!url || url === 'null') return

        if (url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0) {
          let path = String(url).replace(/^\/+/, '')

          if (path.indexOf('uploads/') !== 0) {
            path = 'uploads/properties/image/' + path
          }

          url = 'https://patrimonial.s3.us-west-2.amazonaws.com/' + path
        }

        if (imageList.findIndex((item) => item.url === url) === -1) {
          imageList.push({ id: id, url: url })
        }
      }

      if (!item) return imageList

      if (Array.isArray(item.images)) {
        item.images.forEach((image) => pushImage(image, image.id || 0))
      }

      return imageList
    },
    getCurrentPerson () {
      if (this.property && this.property.person) {
        return this.property.person
      }

      if (this.property && Array.isArray(this.property.responsibilities) && this.property.responsibilities.length > 0) {
        const responsibility = this.property.responsibilities[0]
        if (responsibility && responsibility.person && responsibility.person.name) {
          return responsibility.person.name
        }
      }

      return ''
    },
    safeValue (value) {
      if (value === null || value === undefined || value === '') {
        return 'N/A'
      }

      return value
    }
  }
}
</script>

<style scoped>
.image-viewer {
  border: 1px solid #d7d7d7;
  border-radius: 6px;
  padding: 8px;
  background: #fafafa;
}

.main-image {
  width: 100%;
  max-height: 360px;
  object-fit: contain;
  border-radius: 4px;
  background: #fff;
}

.thumbs {
  display: flex;
  gap: 8px;
  margin-top: 10px;
  overflow-x: auto;
}

.thumb-btn {
  border: 2px solid transparent;
  background: transparent;
  padding: 0;
  border-radius: 4px;
  cursor: pointer;
}

.thumb-btn img {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 4px;
  display: block;
}

.thumb-btn.active {
  border-color: #2c7be5;
}

.sheet-row {
  border-bottom: 1px solid #efefef;
  padding: 6px 0;
  font-size: 13px;
}

.section-title {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 600;
}
</style>
